module.exports = __webpack_public_path__ + "12341f486f7ba6601e83591b74dd4156.svg";